import {Pipe, PipeTransform} from '@angular/core';
import {BlockedStockException} from "@services";

@Pipe({
    name: 'blockedStockException',
    standalone: true
})
export class BlockedStockExceptionPipe implements PipeTransform {
    transform(value: BlockedStockException | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case BlockedStockException.DuplicateSu: return "Duplicate SU";
            default: return value;
        }
    }
}
